import Vue from 'vue'
import App from './App.vue'

import router from '@/router'

Vue.config.productionTip = false

Vue.filter('fmMoney',function (value,len=2,splitChar=false) {
    if(typeof value === 'undefined' || value === null || value === ''){
      return '--';
    }
    value=+value;
    value=parseFloat(value).toFixed(len);
    if(splitChar){
      var temp = value.split('.');
      temp[0]=temp[0].replace(/(\d)(?=(\d{3})+$)/g,"$1.");
      value = temp[0];
      if(temp.length===2){
        value += '.'+temp[1];
      }
    }
    return value;
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


var docEl = document.documentElement;

function setRemUnit() {
  var rem = docEl.clientWidth * 100 / 1336;
  docEl.style.fontSize = rem + 'px'
}
setRemUnit();
window.addEventListener("resize", function() {
  setRemUnit();
});
